var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M25.8333 3.33337H14.1666C12.3333 3.33337 10.8333 4.83337 10.8333 6.66671V33.3334C10.8333 35.1667 12.3333 36.6667 14.1666 36.6667H25.8333C27.6666 36.6667 29.1666 35.1667 29.1666 33.3334V6.66671C29.1666 4.83337 27.6666 3.33337 25.8333 3.33337ZM19.9999 33.3334C19.0833 33.3334 18.3333 32.5834 18.3333 31.6667C18.3333 30.75 19.0833 30 19.9999 30C20.9166 30 21.6666 30.75 21.6666 31.6667C21.6666 32.5834 20.9166 33.3334 19.9999 33.3334Z",
    fill: "#426BF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.66667C17.5 6.20643 17.8731 5.83333 18.3333 5.83333H21.6667C22.1269 5.83333 22.5 6.20643 22.5 6.66667C22.5 7.1269 22.1269 7.5 21.6667 7.5H18.3333C17.8731 7.5 17.5 7.1269 17.5 6.66667Z",
    fill: "#426BF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 29.1667C18.6193 29.1667 17.5 30.286 17.5 31.6667C17.5 33.0474 18.6193 34.1667 20 34.1667C21.3807 34.1667 22.5 33.0474 22.5 31.6667C22.5 30.286 21.3807 29.1667 20 29.1667ZM19.1667 31.6667C19.1667 31.2064 19.5398 30.8333 20 30.8333C20.4602 30.8333 20.8333 31.2064 20.8333 31.6667C20.8333 32.1269 20.4602 32.5 20 32.5C19.5398 32.5 19.1667 32.1269 19.1667 31.6667Z",
    fill: "#426BF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.66667C10 4.36548 11.8655 2.5 14.1667 2.5H25.8333C28.1345 2.5 30 4.36548 30 6.66667V33.3333C30 35.6345 28.1345 37.5 25.8333 37.5H14.1667C11.8655 37.5 10 35.6345 10 33.3333V6.66667ZM14.1667 4.16667C12.786 4.16667 11.6667 5.28595 11.6667 6.66667V33.3333C11.6667 34.714 12.786 35.8333 14.1667 35.8333H25.8333C27.214 35.8333 28.3333 34.714 28.3333 33.3333V6.66667C28.3333 5.28595 27.214 4.16667 25.8333 4.16667H14.1667Z",
    fill: "#426BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.aa1f41a080f318710f42959cedb23639.svg";
export { ForwardRef as ReactComponent };